import * as s from './Table.css'

/**
 * Keys for the colored left edge on table rows.
 * Map via {@link ROW_ACCENT_CLASS} or pass from {@link EntityTableDefinition.getRowAccent}.
 */
export type RowAccent =
  | 'online'
  | 'standby'
  | 'offline'
  | 'fault'
  | 'commissioning'
  | 'verified'
  | 'unverified'
  | 'deleted'
  | 'none'

/** CSS class per accent key (applied on `<tr>`). */
export const ROW_ACCENT_CLASS: Record<RowAccent, string> = {
  online: s.trAccentOnline,
  standby: s.trAccentStandby,
  offline: s.trAccentOffline,
  fault: s.trAccentFault,
  commissioning: s.trAccentCommissioning,
  verified: s.trAccentVerified,
  unverified: s.trAccentUnverified,
  deleted: s.trAccentFault,
  none: '',
}

export function resolveRowAccentClass(accent: string | undefined): string {
  if (!accent || accent === 'none') return ''
  return ROW_ACCENT_CLASS[accent as RowAccent] ?? ''
}
